module.exports = __webpack_public_path__ + "img/ic_info.e0d20c85.svg";